import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useSearchClassName } from './utils';
import { searchTheme } from './theme';
import { SEARCH_CLASS_PREFIX, searchRoot } from './constants';
import { SearchRoot, SearchSuggestionsContainer, SearchSuggestionsListContainer, SearchTextInput } from './style';
import { useSearchBar } from './utils/useSearchBar';
import { SearchSuggestionsList } from './SearchSuggestionsList';
import { SearchIcon } from './SearchIcon';
import { SearchClearAction } from './SearchClearAction';
import { getScalarPropType } from '../../utils/propTypes';
export var Search = forwardRef(function Search(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(SEARCH_CLASS_PREFIX, searchTheme);

  var _useSearchBar = useSearchBar(restProps, ref),
      rootProps = _useSearchBar.rootProps,
      textInputProps = _useSearchBar.textInputProps,
      searchIconProps = _useSearchBar.searchIconProps,
      searchClearActionProps = _useSearchBar.searchClearActionProps,
      suggestionsContainerProps = _useSearchBar.suggestionsContainerProps,
      suggestionListContainerProps = _useSearchBar.suggestionListContainerProps,
      suggestionListProps = _useSearchBar.suggestionListProps,
      disabled = _useSearchBar.disabled,
      isSuggestionsListShown = _useSearchBar.isSuggestionsListShown;

  var classOverride = useSearchClassName(SEARCH_CLASS_PREFIX, className, disabled, isSuggestionsListShown);
  return React.createElement(SearchRoot, Object.assign({
    "data-testid": searchRoot
  }, rootProps, {
    className: classOverride.Root,
    theme: theme,
    disabled: disabled
  }), React.createElement(SearchTextInput, Object.assign({}, textInputProps, {
    before: React.createElement(SearchIcon, Object.assign({}, searchIconProps)),
    after: React.createElement(SearchClearAction, Object.assign({}, searchClearActionProps)),
    className: classOverride.TextInput,
    theme: theme
  })), isSuggestionsListShown ? React.createElement(SearchSuggestionsContainer, Object.assign({}, suggestionsContainerProps, {
    className: classOverride.SuggestionsContainer,
    theme: theme
  }), React.createElement(SearchSuggestionsListContainer, Object.assign({}, suggestionListContainerProps, {
    className: classOverride.SearchSuggestionsList,
    theme: theme
  }), React.createElement(SearchSuggestionsList, Object.assign({}, suggestionListProps, {
    theme: theme,
    groupClassName: classOverride.ListItemGroup
  })))) : null);
});